import React from 'react';
import PropTypes from 'prop-types';
import css from './TenantAdminForm.scss';
import Switch from 'common/Switch';
import { getWord } from 'utils/tenant';

/**
 * @returns {JSX.Element} the Help Desk Information configurations related to the student view of help resources
 */
function StudentHelpPreferences({ setValue, showToStudents, studentDisplayText }) {
    return (
        <div className={css['preference-container']}>
            <div className={css['switch-container']}>
                <Switch aria-labelledby="showToStudents"
                        checked={showToStudents}
                        onChange={(checked) => setValue({ showToStudents: checked })} />
                <label id="showToStudents">Display to Students</label>
                <div className={css['help-text']}>
                    If enabled, this will display on the {getWord('studentHelp', false)} page for students
                </div>
            </div>
            { showToStudents &&
                <div className={css['custom-lang']}>
                    <label htmlFor="studentDisplayText">
                        Header Text for Students on {getWord('studentHelp', false)} Page
                    </label>
                    <input type="text"
                           id="studentDisplayText"
                           placeholder="Help Resources"
                           value={studentDisplayText}
                           onChange={e => setValue({ studentDisplayText: e.target.value })}/>
                </div>
            }
        </div>
    )
}

StudentHelpPreferences.propTypes = {
    setValue: PropTypes.func.isRequired,
    showToStudents: PropTypes.bool,
    studentDisplayText: PropTypes.string
};

export default StudentHelpPreferences;
